import React, { useState } from 'react'
import clsx from 'clsx'
import Button from 'components/shared/Button';
import MessageModal from 'components/shared/modals/MessageModal';
import { ReactComponent as IconInfo } from 'images/info.svg';
import styles from './Info.module.scss';

type InfoProps = {
  children?: React.ReactNode,
  center?: boolean,
  marginTop?: string | undefined,
  style?: any,
  white?: boolean,
  small?: boolean,
  infoMessage?: React.ReactNode,
  className?: string,
  icon?: React.ReactNode,
}

function Info({
  children = null,
  center = false,
  marginTop,
  style,
  white = false,
  small = false,
  className,
  infoMessage,
  icon,
}: InfoProps) {
  const [isModalVisible, setModalVisible] = useState<boolean>(false)

  return (
    <>
      <div
        className={clsx(
          styles.fieldInfo,
          center && styles.fieldInfoCenter,
          white && styles.fieldInfoWhite,
          infoMessage && styles.fieldInfoClickable,
          small && styles.fieldInfoSmall,
          className && className,
        )}
        style={{ marginTop, ...style }}
        onClick={() => {
          if (infoMessage) setModalVisible(true)
        }}
      >
        {
          icon // eslint-disable-line
            ? icon
            : <IconInfo className={styles.infoIcon} />
        }
        <span>
          {children}
        </span>
      </div>
      {isModalVisible ? (
        <MessageModal
          title="Info"
          status="info"
          onClick={() => setModalVisible(false)}
          message={infoMessage || ''}
          buttons={[(
            <Button
              onClick={() => setModalVisible(false)}
            >
              Close
            </Button>
          )]}
        />
      ) : null}
    </>
  )
}

export default Info
